import { createRouter, createWebHistory } from 'vue-router';
import { userRouter } from './user';
import { courseRoutes } from './course';
import { expertRoutes } from './expert';
import { invoiceRoutes } from './invoice';
import { mallRoutes } from './mall';
const routes = [
    {
        path: '/new-course',
        name: 'newCourse',
        component: () => import('@/views/learn/new-course.vue'),
        meta: {
            title: '新课程'
        }
    },
    {
        path: '/list',
        name: 'learnList',
        component: () => import('@/views/learn/list/index.vue'),
        meta: {
            title: '列表页'
        }
    },
    {
        path: '/list/pbl',
        name: 'learnListPbl',
        component: () => import('@/views/learn/list/pbl.vue'),
        meta: {
            title: 'PBL专题列表'
        }
    },
    {
        path: '/list/omo',
        name: 'learnListOMO',
        component: () => import('@/views/learn/list/omo.vue'),
        meta: {
            title: 'OMO训练营'
        }
    },
    {
        path: '/list/exercise',
        name: 'learnListExercise',
        component: () => import('@/views/learn/medicase/index.vue'),
        meta: {
            title: '病例练习'
        }
    },
    {
        path: '/list/onlinetrain',
        name: 'learnListOTrain',
        component: () => import('@/views/learn/list/onlineTrain.vue'),
        meta: {
            title: ' 线上共学营'
        }
    },
    {
        path: '/guide/exercise',
        name: 'guideExercise',
        component: () => import('@/views/learn/guide/exercise.vue'),
        meta: {
            title: '病例练习'
        }
    },
    {
        path: '/guide/exam',
        name: 'guideExam',
        component: () => import('@/views/learn/guide/exam.vue'),
        meta: {
            title: '病例练习'
        }
    },
    {
        path: '/guide/:type/:id',
        name: 'guidePage',
        component: () => import('@/views/learn/guide/index.vue'),
        meta: {
            title: '好医术'
        }
    },
    {
        path: '/order/:module/:orderId',
        name: 'orderDetail',
        component: () => import('@/views/order/detail.vue'),
        meta: {
            title: '确认订单'
        }
    },
    {
        path: '/order/payresult/:module/:orderId',
        name: 'orderResult',
        component: () => import('@/views/order/payresult.vue'),
        meta: {
            title: '订单结果'
        }
    },
    {
        path: '/detail/exercise/:id',
        name: 'detailExercise',
        component: () => import('@/views/learn/detail/exercise.vue'),
        meta: {
            title: '练习'
        }
    },
    {
        path: '/detail/exam/:id',
        name: 'detailExam',
        component: () => import('@/views/learn/detail/exam.vue'),
        meta: {
            title: '练习'
        }
    },
    {
        path: '/detail/exercise/result/:id',
        name: 'exerciseResult',
        component: () => import('@/views/learn/detail/result.vue'),
        meta: {
            title: '练习结果'
        }
    },
    {
        path: '/descExercise',
        name: 'descExercise',
        component: () => import('@/views/learn/detail/index.vue'),
        meta: {
            title: '首页练习'
        }
    },
    {
        path: '/exercise',
        name: 'exercise',
        component: () => import(/* webpackChunkName: "exercise" */ '../views/exercise/index.vue'),
        meta: {
            title: '练习',
            recordScroll: true
        }
    },
    {
        path: '/lian',
        name: 'lian',
        component: () => import(/* webpackChunkName: "exercise" */ '../views/exercise/lian.vue'),
        meta: {
            title: '练习',
            recordScroll: true
        }
    },
    {
        path: '/exercise/target',
        name: 'ExerciseTarget',
        component: () => import(
        /* webpackChunkName: "exercise-target" */ '../views/exercise/target.vue'),
        meta: {
            title: '学习目标'
        }
    },
    {
        path: '/exercise/question',
        name: 'ExerciseQuestion',
        component: () => import(
        /* webpackChunkName: "exercise-question" */ '../views/exercise/question.vue'),
        meta: {
            title: '我要提问'
        }
    },
    {
        path: '/exercise/question/list',
        name: 'ExerciseQuestionList',
        component: () => import(
        /* webpackChunkName: "exercise-question-list" */ '../views/exercise/question-list.vue'),
        meta: {
            title: '查看问题'
        }
    },
    {
        path: '/exercise/question/lecturer/list',
        name: 'QuestionLecturerList',
        component: () => import(
        /* webpackChunkName: "question-lecturer-list" */ '../views/exercise/question-lecturer-list.vue'),
        meta: {
            title: '查看问题'
        }
    },
    {
        path: '/exercise/question/detail',
        name: 'ExerciseQuestionDetail',
        component: () => import(
        /* webpackChunkName: "exercise-question-detail" */ '../views/exercise/question-detail.vue'),
        meta: {
            title: '问题讨论'
        }
    },
    {
        path: '/article/list',
        name: 'ArticleList',
        component: () => import(
        /* webpackChunkName: "article-list" */ '../views/article/list.vue'),
        meta: {
            title: '文章列表'
        }
    },
    {
        path: '/article/:id',
        name: 'ArticleDetail',
        component: () => import(
        /* webpackChunkName: "article-detail" */ '../views/article/index.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/pdf/viewer',
        name: 'PdfViewer',
        component: () => import('@/views/pdf/pdf.vue'),
        meta: {
            title: '资料预览'
        }
    },
    {
        path: '/exam/:id',
        name: 'ExamDetail',
        component: () => import('@/views/exam/index.vue'),
        meta: {
            title: '病例练习'
        }
    },
    {
        path: '/new/exercise',
        name: 'Exercise',
        component: () => import(/* webpackChunkName: "exercise" */ '../views/exercise/index.vue'),
        meta: {
            title: '练习'
        }
    },
    {
        path: '/exercise/rank',
        name: 'ExerciseRank',
        component: () => import(/* webpackChunkName: "exercise" */ '@/views/rank/index.vue'),
        meta: {
            title: '排行榜'
        }
    },
    {
        path: '/useguide',
        name: 'useGuide',
        component: () => import('@/views/useGuide/index.vue'),
        meta: {
            title: '使用指南'
        }
    },
    {
        path: '/medicase',
        name: 'medicaseHome',
        component: () => import('@/views/learn/medicase/index.vue'),
        meta: {
            title: '病例练习'
        }
    },
    {
        path: '/medicase/success',
        name: 'successVip',
        component: () => import('@/views/learn/medicase/success.vue'),
        meta: {
            title: '领取成功'
        }
    },
    {
        path: '/medicase/record',
        name: 'exerciseRecord',
        component: () => import('@/views/learn/medicase/record.vue'),
        meta: {
            title: '练习记录'
        }
    },
    {
        path: '/medicase/report',
        name: 'exerciseReport',
        component: () => import('@/views/learn/medicase/report.vue'),
        meta: {
            title: '练习报告'
        }
    },
    {
        path: '/medicase/list',
        name: 'medicaseList',
        component: () => import('@/views/learn/medicase/list.vue'),
        meta: {
            title: '全部病例',
            keepAlive: true
        }
    },
    {
        path: '/calendar/list',
        name: 'calendarList',
        component: () => import('@/views/calendar/list.vue'),
        meta: {
            title: '日历列表',
            keepAlive: true
        }
    },
    {
        path: '/calendar/detail/:id',
        name: 'calendarDetail',
        component: () => import('@/views/calendar/detail.vue'),
        meta: {
            title: '知识点日历',
            keepAlive: true
        }
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/search/index.vue'),
        meta: {
            title: '搜索',
            keepAlive: true
        }
    },
    {
        path: '/live/list',
        name: 'liveList',
        component: () => import('@/views/live/list.vue'),
        meta: {
            title: '直播列表'
        }
    },
    {
        path: '/exchange/code/index',
        name: 'exchangeCode',
        component: () => import('@/views/exchange/code.vue'),
        meta: {
            title: '兑换码'
        }
    },
    {
        path: '/exchange/code/manual',
        name: 'exchangeCodeManual',
        component: () => import('@/views/exchange/manualInput.vue'),
        meta: {
            title: '手工输入'
        }
    },
    {
        path: '/exchange/select/:code',
        name: 'exchangeSelectCourse',
        component: () => import('@/views/exchange/course.vue'),
        meta: {
            title: '选择课程'
        }
    },
    {
        path: '/exchange/detail/:code',
        name: 'exchangeDetail',
        component: () => import('@/views/exchange/detail.vue'),
        meta: {
            title: '兑换详情'
        }
    },
    {
        path: '/exchange/:courseId',
        name: 'exchangeCourse',
        component: () => import('@/views/exchange/index.vue'),
        meta: {
            title: '练习卡兑换'
        }
    },
    {
        path: '/exchange/result/:courseId',
        name: 'exchangeResult',
        component: () => import('@/views/exchange/result.vue'),
        meta: {
            title: '兑换结果'
        }
    },
    ...courseRoutes,
    ...expertRoutes,
    ...invoiceRoutes,
    ...mallRoutes
];
userRouter.map(val => {
    routes.push(val);
});
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        return new Promise(resolve => {
            if (to.name === from.name) {
                resolve();
                return;
            }
            const scroll = to.meta.recordScroll;
            setTimeout(() => {
                if (savedPosition) {
                    resolve(scroll ? savedPosition : { left: 0, top: 0 });
                }
                else {
                    resolve({ left: 0, top: 0 });
                }
            }, scroll ? 400 : 0);
        });
    },
    routes
});
export default router;
